import { useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { useProductos } from '../../hooks/useProductos';
import { useCategorias } from '../../hooks/useCategorias';
import { ProductCard } from '../../components/public/ProductCard';
import { CategoryFilter } from '../../components/public/CategoryFilter';
import { Spinner } from '../../components/shared/Spinner';
import { SearchIcon } from '../../components/shared/icons';

export function CatalogoPage() {
  const [searchParams, setSearchParams] = useSearchParams();
  const categoriaId = searchParams.get('categoriaId') ?? undefined;
  const [texto, setTexto] = useState('');

  const { data: productos, isLoading } = useProductos({ categoriaId, texto: texto || undefined });
  const { data: categorias } = useCategorias();

  return (
    <section className="max-w-[1280px] mx-auto px-4 sm:px-6 md:px-14 py-8 md:py-11 flex flex-col gap-6">
      <h1 className="text-3xl md:text-4xl font-display font-semibold text-[oklch(28%_0.03_50)]">Catálogo</h1>

      <div className="w-full max-w-[420px] flex items-center gap-2.5 bg-surface border border-border rounded-lg px-4 py-2.5">
        <SearchIcon width={17} height={17} className="text-ink-muted" />
        <input
          value={texto}
          onChange={(e) => setTexto(e.target.value)}
          placeholder="Buscar productos..."
          data-testid="catalog-search-input"
          className="flex-1 bg-transparent text-sm outline-none placeholder:text-ink-muted"
        />
      </div>

      <CategoryFilter
        categorias={categorias ?? []}
        categoriaSeleccionada={categoriaId}
        onSeleccionar={(id) => setSearchParams(id ? { categoriaId: id } : {})}
      />

      {isLoading ? (
        <Spinner />
      ) : (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {(productos ?? []).map((p) => (
            <ProductCard key={p.id} producto={p} />
          ))}
          {productos?.length === 0 && (
            <p className="col-span-full text-center text-ink-muted py-10">
              No encontramos productos con ese filtro.
            </p>
          )}
        </div>
      )}
    </section>
  );
}
